






















import {Component, Prop, Vue} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import LineItemView from '@/components/LineItemView.vue';
import {IOrder} from '@/models/IOrder';

@Component({
  components: {
    LineItemView
  }
})

export default class OrdersSelectionTable extends Vue {
  @Prop() orders!: IOrder[];
  @Prop() value!: IOrder[];

  headers: DataTableHeader[] = [
    {text: 'Order', value: 'order_name', width: 100, sortable: true},
    {text: 'Country', value: 'shipping_address.country', width: 100, sortable: true},
    {text: 'Products', value: 'line_items', sortable: true},
  ];
}
